<template>
  <div :class="mergeClasses('tw-flex tw-items-center', wrapperClasses)">
    <input
      v-bind="$attrs"
      :id="id"
      type="radio"
      :checked="modelValue === value"
      :value="value"
      @input="handleInputChange"
    />
    <FormLabel
      class="tw-ml-2"
      :id="id"
      is-checkbox-label
      :is-required="isRequired"
      :tooltip="tooltip"
    >
      <slot />
    </FormLabel>
  </div>
</template>

<script setup>
import FormLabel from './FormLabel.vue'
import { getUniqueId } from '@/shared/utils/uniqueId.js'
import { mergeClasses } from '@/shared/utils/mergeClasses.js'

const emit = defineEmits(['update:checked', 'update:modelValue', 'input'])

const props = defineProps({
  modelValue: {
    type: [String, Number, Object],
    default: '',
  },
  value: {
    type: [String, Number, Object],
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: '',
  },
  wrapperClasses: {
    type: String,
    default: '',
  },
})

const id = `growthmentor-radio-${getUniqueId()}`

const handleInputChange = (event) => {
  if (event.target.checked) emit('update:checked', props.value)
  emit('update:modelValue', props.value)
  // 'input' emit is backward compatibility with Vue 2 v-model
  emit('input', props.value)
}
</script>

<script>
export default {
  inheritAttrs: false,
}
</script>
